import { z } from "zod";
export const ProformaJurisdictionSchema = z.enum(["PK", "AE"]);
export const FormationStatusSchema = z.enum(["proforma", "formed"]);
export const DataRoomReportUseSchema = z.enum(["financial", "operational", "both"]);
export const DataRoomIndexStateSchema = z.enum(["held", "released"]);
const DateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
/** Fields still empty when someone marks an entity formed. */
export function formationGaps(input) {
    if (input.formationStatus !== "formed")
        return [];
    const gaps = [];
    if (!input.legalName?.trim())
        gaps.push("legalName");
    if (!input.registrationNumber?.trim())
        gaps.push("registrationNumber");
    if (!input.formedOn)
        gaps.push("formedOn");
    return gaps;
}
function requireFormedDetails(value, ctx) {
    for (const gap of formationGaps(value)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [gap],
            message: "Required once the entity is formed",
        });
    }
}
export const ProformaEntitySchema = z.object({
    id: z.string().uuid(),
    roomId: z.string().uuid(),
    workingName: z.string(),
    jurisdiction: ProformaJurisdictionSchema,
    formationStatus: FormationStatusSchema,
    legalName: z.string().nullable(),
    registrationNumber: z.string().nullable(),
    formedOn: DateSchema.nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ProformaEntityCreateSchema = z
    .object({
    workingName: z.string().min(1).max(200),
    jurisdiction: ProformaJurisdictionSchema,
    formationStatus: FormationStatusSchema.default("proforma"),
    legalName: z.string().max(200).nullable().optional(),
    registrationNumber: z.string().max(80).nullable().optional(),
    formedOn: DateSchema.nullable().optional(),
})
    .superRefine(requireFormedDetails);
export const ProformaEntityUpdateSchema = z
    .object({
    workingName: z.string().min(1).max(200).optional(),
    jurisdiction: ProformaJurisdictionSchema.optional(),
    formationStatus: FormationStatusSchema.optional(),
    legalName: z.string().max(200).nullable().optional(),
    registrationNumber: z.string().max(80).nullable().optional(),
    formedOn: DateSchema.nullable().optional(),
})
    .superRefine((value, ctx) => {
    if (value.formationStatus !== "formed")
        return;
    requireFormedDetails({
        formationStatus: "formed",
        legalName: value.legalName,
        registrationNumber: value.registrationNumber,
        formedOn: value.formedOn,
    }, ctx);
});
export const DataRoomSchema = z.object({
    id: z.string().uuid(),
    projectId: z.string().uuid(),
    name: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const DataRoomCreateSchema = z.object({
    projectId: z.string().uuid(),
    name: z.string().min(1).max(200),
});
export const DataRoomIndexItemSchema = z.object({
    id: z.string().uuid(),
    roomId: z.string().uuid(),
    entityId: z.string().uuid().nullable(),
    title: z.string(),
    reportUse: DataRoomReportUseSchema,
    state: DataRoomIndexStateSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const DataRoomIndexItemCreateSchema = z.object({
    title: z.string().min(1).max(300),
    entityId: z.string().uuid().nullable().optional(),
    reportUse: DataRoomReportUseSchema,
});
export const DataRoomIndexItemUpdateSchema = z.object({
    state: DataRoomIndexStateSchema,
});
export const DataRoomDetailSchema = DataRoomSchema.extend({
    entities: z.array(ProformaEntitySchema),
    index: z.array(DataRoomIndexItemSchema),
});
export const DataRoomListResponseSchema = z.object({
    rooms: z.array(DataRoomSchema),
});
//# sourceMappingURL=data-room.js.map